// Desc: Constants for the CreateActionDialog component action types
export const NAVIGATE_ACTION = "Navigate";
export const NEW_ACTION = "New";
export const LINK_ACTION = "Link";
export const EDIT_ACTION = "Edit";
export const GENERATE_SHARED_FORM_LINK_ACTION = "Generate Shared Form Link";
export const ADVANCED_REPORT_ACTION = "Advanced Report";
export const DELETE_ACTION = "Delete";
export const UNLINK_ACTION = "Unlink";
export const EXTERNAL_URL_ACTION = "Navigate to External URL";
export const ATTRIBUTE_URL_ACTION = "Navigate to Attribute URL";
export const REFRESH_ACTION = "Refresh";
export const BACK_ACTION = "Back";
export const LIST_DESIGNER_ACTION = "List Designer";
export const CHART_DESIGNER_ACTION = "Chart Designer";
export const CHART_VIEWER_ACTION = "Chart Viewer";
export const WORKFLOW_ACTION = "Workflow";
export const BULK_SAVE_ACTION = "Bulk Save";

export const NAVIGATE_TO_PAGE_ACTION_TYPES = [NAVIGATE_ACTION, NEW_ACTION, LINK_ACTION, EDIT_ACTION];

export const ACTIONS_WITH_IDENTIFIER = [GENERATE_SHARED_FORM_LINK_ACTION, WORKFLOW_ACTION];

export const ALL_NAVIGATE_ACTION_TYPES = [
    NAVIGATE_ACTION,
    NEW_ACTION,
    LINK_ACTION,
    EDIT_ACTION,
    EXTERNAL_URL_ACTION,
    ATTRIBUTE_URL_ACTION
];